import { PayloadAction } from '@reduxjs/toolkit';

import { ExtraReducerBuilder } from '../../types/shared';
import { WritableQuoteBuilderStateType } from '../../types/state';
import { createSnapQuoteAttachment } from '../endpoints/create-snap-quote-attachment';
import { withSaveStateUpdate } from '../utilities/with-save-state-update';

function createSnapQuoteAttachmentFulfilled(
  state: WritableQuoteBuilderStateType,
  action: PayloadAction<typeof createSnapQuoteAttachment.Types.ResultType>,
) {
  const createdByDisplayName = {
    displayName: action.payload.createdBy?.displayName ?? 'unknown',
  };

  state.documentIds.push(action.payload.id);
  state.documents[action.payload.id] = {
    id: action.payload.id,
    fileName: action.payload.fileName,
    fileType: action.payload.fileType,
    createdBy: createdByDisplayName,
    createdAt: action.payload.createdAt,
  };
}

export function createSnapQuoteAttachmentReducer(builder: ExtraReducerBuilder) {
  builder.addMatcher(
    createSnapQuoteAttachment.matchFulfilled,
    withSaveStateUpdate(createSnapQuoteAttachmentFulfilled),
  );
}
